(function () {
  // ── CONFIGURATION ──────────────────────────────────────────
  const CLASS_TAG = "easify";
  const MAX_CLASS_QTY = 1;
  const BLOCK_MESSAGE = "Only one class allowed per order.";
  // ───────────────────────────────────────────────────────────

  const originalFetch = window.fetch.bind(window);

  async function getProductTags(handle) {
    const res = await originalFetch(`/products/${handle}.js`);
    const product = await res.json();
    return product.tags || [];
  }

  async function getCartData() {
    const res = await originalFetch("/cart.js");
    return await res.json();
  }

  async function getClassQtyInCart() {
    const cart = await getCartData();
    let qty = 0;
    for (const item of cart.items) {
      const tags = await getProductTags(item.handle);
      if (tags.includes(CLASS_TAG)) qty += item.quantity;
    }
    return qty;
  }

  function getCurrentHandle() {
    return window.ShopifyAnalytics?.meta?.product?.handle
      || document.querySelector('[data-product-handle]')?.dataset.productHandle;
  }

  async function isCurrentProductAClass() {
    const handle = getCurrentHandle();
    if (!handle) return false;
    const tags = await getProductTags(handle);
    return tags.includes(CLASS_TAG);
  }

  function blockButtons() {
    document.querySelectorAll('button[name="add"], button[type="submit"].product-form__submit')
      .forEach(btn => {
        btn.disabled = true;
        btn.setAttribute("data-class-blocked", "true");
        btn.textContent = BLOCK_MESSAGE;
        btn.style.backgroundColor = "#cc0000";
        btn.style.color = "#ffffff";
        btn.style.opacity = "1";
        btn.style.cursor = "not-allowed";
        btn.style.border = "none";
      });
  }

  // ── Intercept ONLY /cart/add.js fetch calls ──
  window.fetch = async function (...args) {
    const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";

    // Only intercept the exact Shopify cart add endpoint
    if (/\/cart\/add(\.js)?(\?.*)?$/.test(url)) {
      const isClass = await isCurrentProductAClass();
      if (isClass) {
        const cartQty = await getClassQtyInCart();
        if (cartQty >= MAX_CLASS_QTY) {
          blockButtons();
          return new Response(
            JSON.stringify({ status: 422, message: BLOCK_MESSAGE, description: BLOCK_MESSAGE }),
            { status: 422, headers: { "Content-Type": "application/json" } }
          );
        }
      }
    }

    // Everything else — including Easify — passes through untouched
    return originalFetch.apply(this, args);
  };

  // ── Change "Add to Cart" button text when product is sold out ──
  function updateSoldOutButtons() {
    document.querySelectorAll('button[name="add"], button[type="submit"].product-form__submit')
      .forEach(btn => {
        if (btn.disabled && !btn.getAttribute("data-class-blocked")) {
          btn.textContent = "Sold out";
        }
      });
  }

  const observer = new MutationObserver((mutations, obs) => {
    obs.disconnect();
    updateSoldOutButtons();
    obs.observe(document.body, { childList: true, subtree: true });
  });

  window.addEventListener("load", () => {
    updateSoldOutButtons();
    observer.observe(document.body, { childList: true, subtree: true });
  });

})();